module.exports = __webpack_public_path__ + "img/coupon1.26e0701b.png";